export const SETTING_LIST_INITING = 'SETTING_LIST_INITING'
export const SETTING_LIST_REQUESTING = 'SETTING_LIST_REQUESTING'
export const SETTING_LIST_SUCCESS = 'SETTING_LIST_SUCCESS'
export const SETTING_LIST_ERROR = 'SETTING_LIST_ERROR'

export const SETTING_UPDATE_STORE_REQUESTING = 'SETTING_UPDATE_STORE_REQUESTING'
export const SETTING_UPDATE_STORE_SUCCESS = 'SETTING_UPDATE_STORE_SUCCESS'
export const SETTING_UPDATE_STORE_ERROR = 'SETTING_UPDATE_STORE_ERROR'

export const SETTING_GET_CONFIG_REQUESTING = 'SETTING_GET_CONFIG_REQUESTING'

export const SETTING_LIST_API = '/api/v1/management/get_setting_by_store'
export const SETTING_UPDATE_STORE_API = '/api/v1/management/update_setting_by_store'
export const SETTING_GET_CONFIG_API = '/api/v1/management/get_setting_by_key_of_store'



// WEBPACK FOOTER //
// ./src/views/Setting/constants.js